import logo from "../assets/ioEnergyLogo.png";
import "./Navbar.css";
import { Container, Grid } from "@mui/material";
import DesktopSignUpStepper from "./DesktopSignUpStepper";
import UserAvatar from "./UserAvatar";

function Navbar(props) {
  return (
    <>
      <Container>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Grid>
            <a
              href="https://www.ioenergy.com.au/"
              style={{ display: "inline-block" }}
            >
              <img
                style={{ display: "block" }}
                src={logo}
                alt="logo"
                className="logo"
              ></img>
            </a>
          </Grid>
          {props.user.user ? (
            <Grid>
              <UserAvatar
                setUser={props.setUser}
                setActiveStep={props.setActiveStep}
                user={props.user.user}
              />
            </Grid>
          ) : null}
        </Grid>
      </Container>
      <Container>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent={"space-between"}
        >
          {props.user.user && !props.mediaQuery ? (
            <Grid item sx={{ flexGrow: 1, pt: 1, pb: 2 }}>
              <DesktopSignUpStepper
                setActiveStep={props.setActiveStep}
                stepperState={props.stepperState}
              />
            </Grid>
          ) : null}

          {/* {props.user.user && !props.mediaQuery ? (
            <UserAvatar
              setUser={props.setUser}
              setActiveStep={props.setActiveStep}
              user={props.user.user}
            />
          ) : null} */}
        </Grid>
      </Container>
    </>
  );
}

export default Navbar;
